(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conjunt-mofo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Inicializar Swiper principal
    const swiperPrincipal = new Swiper('.swiper-conjuntos', {
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
        navigation: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 500
    });
    
    // Objeto para armazenar os swipers de produtos
    const produtosSwipers = [];
    
    // Inicializar Swipers de produtos para cada slide
    document.querySelectorAll('.swiper-produtos').forEach((swiperEl, index) => {
        const swiperProdutos = new Swiper(swiperEl, {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: swiperEl.nextElementSibling,
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                },
            },
            autoHeight: true,
            navigation: false
        });
        
        produtosSwipers.push(swiperProdutos);
    });
    
    // Função para lidar com cliques nos botões de opção
    function handleOptionClick(button, slideIndex, productIndex) {
        if(!button.classList.contains('active-conjunt')) {
            // Remover classe ativa de todos os botões
            document.querySelectorAll('.button-option').forEach(btn => {
                btn.classList.remove('active-conjunt');
            });
            
            // Adicionar classe ativa ao botão clicado
            button.classList.add('active-conjunt');
            
            // Mudar para o slide correspondente do swiper principal
            swiperPrincipal.slideTo(slideIndex);
            
            // Mudar para o slide correspondente do swiper de produtos
            if (produtosSwipers[slideIndex]) {
                produtosSwipers[slideIndex].slideTo(productIndex);
            }
        }
    }
    
    // Adicionar event listeners aos botões
    document.querySelectorAll('.button-option').forEach((button) => {
        button.addEventListener('click', function() {
            // Encontrar o índice do slide pai
            const slide = this.closest('.swiper-slide');
            const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
            
            // Determinar qual produto o botão representa
            let productIndex = 0;
            if (this.classList.contains('button-product-two')) {
                productIndex = 1;
            }
            
            handleOptionClick(this, slideIndex, productIndex);
        });
    });
    
    // Atualizar botões ativos quando o slide mudar
    swiperPrincipal.on('slideChange', function() {
        const activeIndex = swiperPrincipal.realIndex;
        const activeSlide = swiperPrincipal.slides[activeIndex];
        
        // Remover classe ativa de todos os botões
        document.querySelectorAll('.button-option').forEach(btn => {
            btn.classList.remove('active-conjunt');
        });
        
        // Ativar o primeiro botão do slide atual
        const firstButton = activeSlide.querySelector('.button-option');
        if (firstButton) {
            firstButton.classList.add('active-conjunt');
        }
    });
    
    // Atualizar botões ativos quando o produto mudar
    produtosSwipers.forEach((swiper, slideIndex) => {
        swiper.on('slideChange', function() {
            const activeSlide = swiperPrincipal.slides[slideIndex];
            if (!activeSlide) return;
            
            // Remover classe ativa de todos os botões deste slide
            activeSlide.querySelectorAll('.button-option').forEach(btn => {
                btn.classList.remove('active-conjunt');
            });
            
            // Ativar o botão correspondente ao produto atual
            const activeProductIndex = swiper.activeIndex;
            const buttonToActivate = activeSlide.querySelector(activeProductIndex === 0 ? '.button-product-one' : '.button-product-two');
            if (buttonToActivate) {
                buttonToActivate.classList.add('active-conjunt');
            }
        });
    });
    
    // Inicializar estado dos botões
    setTimeout(() => {
        const firstSlide = swiperPrincipal.slides[swiperPrincipal.activeIndex];
        if (firstSlide) {
            const firstButton = firstSlide.querySelector('.button-option');
            if (firstButton) {
                firstButton.classList.add('active-conjunt');
            }
        }
    }, 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
